/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProfitByAccounts { 
    designation?: string | null;
    description?: string | null;
    currency?: string | null;
    profitAmount?: number;
    profitAmountBC?: number;
    part?: number;
}

